export const GENERIC_ERROR_MESSAGE = 'Something went wrong, please try again later';

export function getErrorMessage(error: any, fallback = GENERIC_ERROR_MESSAGE): string {
  const candidates = [error?.detail, error?.title, error?.error?.detail, error?.message];

  const message = candidates.find(
    (candidate) => typeof candidate === 'string' && candidate.trim().length > 0,
  );

  return message ?? fallback;
}

export function flattenErrors(errObj: any): string[] {
  const messages: string[] = [];

  function collectStrings(obj: any) {
    if (!obj) return;
    if (typeof obj === 'string') {
      messages.push(obj);
    } else if (Array.isArray(obj)) {
      obj.forEach(collectStrings);
    } else if (typeof obj === 'object') {
      Object.values(obj).forEach(collectStrings);
    }
  }

  collectStrings(errObj);

  return messages.length > 0 ? messages : ['Please fill in all required fields.'];
}
